import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import Section from './Section'
import SectionTitle from './SectionTitle'

const ITEMS = [
  {
    key: 'reminders',
    icon: 'M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0',
  },
  {
    key: 'quietHours',
    icon: 'M21.752 15.002A9.718 9.718 0 0118 15.75c-5.385 0-9.75-4.365-9.75-9.75 0-1.33.266-2.597.748-3.752A9.753 9.753 0 003 11.25C3 16.635 7.365 21 12.75 21a9.753 9.753 0 009.002-5.998z',
  },
  {
    key: 'unsubscribe',
    icon: 'M15 12H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z',
  },
  {
    key: 'qr',
    icon: 'M3.75 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 013.75 9.375v-4.5zM3.75 14.625c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5a1.125 1.125 0 01-1.125-1.125v-4.5zM13.5 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 0113.5 9.375v-4.5zM13.5 14.25h2.25v2.25H13.5v-2.25zm4.5 2.25h2.25v2.25H18v-2.25zm-4.5 4.5h2.25V18H13.5v3z',
  },
  {
    key: 'resume',
    icon: 'M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z',
  },
  {
    key: 'languages',
    icon: 'M10.5 21l5.25-11.25L21 21m-9-3h7.5M3 5.621a48.474 48.474 0 016-.371m0 0c1.12 0 2.233.038 3.334.114M9 5.25V3m3.334 2.364C11.176 10.658 7.69 15.08 3 17.502m9.334-12.138c.896.061 1.785.147 2.666.257m-4.589 8.495a18.023 18.023 0 01-3.827-5.802',
  },
]

const ParticipationSection: React.FC = () => {
  const intl = useIntl()

  return (
    <Section>
      <SectionTitle
        title={intl.formatMessage({ id: 'marketing.participation.title' })}
        subtitle={intl.formatMessage({ id: 'marketing.participation.subtitle' })}
      />

      <div className="grid gap-4 sm:gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {ITEMS.map((item) => (
          <div key={item.key} className="bg-surface rounded-xl border border-border-light p-5">
            <div className="inline-flex items-center justify-center h-10 w-10 rounded-lg bg-primary/10 text-primary mb-3">
              <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d={item.icon} />
              </svg>
            </div>
            <h3 className="text-base font-semibold text-foreground mb-1">
              <FormattedMessage id={`marketing.participation.${item.key}.title`} />
            </h3>
            <p className="text-sm text-foreground-muted">
              <FormattedMessage id={`marketing.participation.${item.key}.text`} />
            </p>
          </div>
        ))}
      </div>
    </Section>
  )
}

export default ParticipationSection
